import { get, post, deleteRequest, patch } from 'utils/api';

export const getSessionLevelOffers = (data) => {
  return get(`/sessionLevelOffers`, data);
};

export const getSessionLevelOfferById = (id) => {
  return get(`/sessionLevelOffers?id=${id}`);
};

export const addSessionLevelOffer = (data) => {
  return post(`/sessionLevelOffers`, data);
};

export const updateSessionLevelOffer = (data) => {
  const id = data.id;
  delete data['id'];
  return patch(`/sessionLevelOffers?id=${id}`, data);
};

export const deleteSessionLevelOffer = ({ id, start_date, end_date }) => {
  const end = end_date ? `&end_date=${encodeURIComponent(end_date)}` : '';
  return deleteRequest(`/sessionLevelOffers?id=${id}&start_date=${encodeURIComponent(start_date)}${end}`);
};

export const sessionLevelOffer = {
  getSessionLevelOffers,
  getSessionLevelOfferById,
  addSessionLevelOffer,
  updateSessionLevelOffer,
  deleteSessionLevelOffer,
};
